module.exports = __webpack_public_path__ + "img/平台建设方案.905dc854.svg";